import { message } from "antd";
import { useState, useEffect } from "react";
import ServiceContent from "../assets/service-content.jpg";
import ServiceContentMobile from "../assets/service-content-mobile.jpg";
import { Link } from "react-router-dom";
import { getGroup } from "../services/api";
import { GROUP_NAME, MAIN_ITEMS } from "../config/constants";

interface MainData {
  bannerImages: string[];
  mobileContentImages: string[];
  videoUrl: string;
  partners: Array<{
    id: number;
    category: string;
    logo: string;
    url: string;
  }>;
}

interface HomeProps {
  mainData: MainData;
}

const getYoutubeVideoId = (url: string) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

export default function Home({ mainData }: HomeProps): JSX.Element {
  const { mobileContentImages, videoUrl } = mainData;

  return (
    <>
      {mobileContentImages.length > 0 && (
        mobileContentImages.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`mobile content ${index + 1}`}
            className="w-full h-full object-cover"
            width={1920}
            height={1080}
          />
        ))
      )}

      <Link className="flex justify-center overflow-x-auto" to="/combo">
        <img
          src={ServiceContent}
          alt="combo.png"
          className="hidden xl:block object-cover h-[420px]"
        />
        <img
          src={ServiceContentMobile}
          alt="combo.png"
          className="block xl:hidden object-cover"
        />
      </Link>

      {videoUrl && getYoutubeVideoId(videoUrl) && (
          <iframe
          src={`https://www.youtube.com/embed/${getYoutubeVideoId(videoUrl)}?autoplay=0&controls=1&rel=0&showinfo=0&fs=1`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="w-full aspect-[16/9]"
          style={{ border: 'none' }}
        />
      )}
    </>
  );
}
